<article class="edge-card flex items-start justify-between gap-4 text-dc-navy">
  <div class="flex-1 space-y-2 leading-snug">
    @if (topLabel) {
    <p class="text-xs font-semibold uppercase tracking-wide">
      {{ topLabel }}
    </p>
    }
    @if (title) {
    <p class="text-base font-semibold">
      {{ title }}
    </p>
    }
    @for (line of normalizedDescriptions; track line.text; let i = $index) {
    <p class="text-sm" [attr.dir]="line.dir ?? null">
      {{ line.text }}
    </p>
    }
    @if (linkText) {
    <button
      type="button"
      class="text-xs underline font-semibold text-dc-navy"
      (click)="handleLinkClick($event)"
    >
      {{ linkText }}
    </button>
    }
    <ng-content></ng-content>
  </div>
  @if (showActions) {
  <div class="flex flex-col items-end gap-2 shrink-0">
    @if (showEdit) {
    <button
      type="button"
      class="text-sm font-semibold underline text-dc-navy"
      (click)="edit.emit()"
    >
      {{ editLabel }}
    </button>
    }
    @if (showRemove) {
    <button
      type="button"
      class="text-2xl leading-none text-dc-navy hover:text-red-600"
      (click)="remove.emit()"
      [attr.aria-label]="removeAriaLabel"
    >
      &times;
    </button>
    }
  </div>
  }
</article>
